import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { Box } from '@/components/Box';
import { SectionHeader } from '@/components/SectionHeader';
import type {
  AllSelectedProducts,
  Product,
} from '@/hooks/useAllSelectedProductsState';
import type { StrapAddToBagBuckle } from '@/hooks/useBucklesAndTools';
import type { SetState } from '@/lib/types';
import { ProductItem } from '@/views/ShoppingBagView/components/ShoppingBagStrapDrawer/components';

import * as M from '../../messages';
import * as S from './BucklesSection.styles';

export interface BucklesSectionProps {
  allProduct?: AllSelectedProducts | null; //all selected products
  buckles: StrapAddToBagBuckle[];
  setAllSelectedProducts: SetState<AllSelectedProducts>;
}

export const BucklesSection = ({
  allProduct,
  buckles,
  setAllSelectedProducts,
}: BucklesSectionProps) => {
  const { formatMessage } = useIntl();

  const [selectedSku, setSelectedSku] = useState<null | string>(null);
  useEffect(() => {
    if (allProduct?.products?.length) {
      const seletedSku = allProduct?.products.find(
        (item: Product) => item.productTypeSlug === 'buckle',
      );
      setSelectedSku(seletedSku?.sku ?? null);
    }
  }, [allProduct]);
  return (
    <Box data-test-id='BucklesSectionWrapper'>
      <SectionHeader
        data-test-id='BucklesSectionSectionHeader'
        disableGutters
        numberOfColoredWords={0}
        sizeDesktop={24}
        sizeMobile={20}
        text={formatMessage(M.defined.getABuckleForYourStrap)}
        textAlign='center'
      />
      <Box marginBottom={2} />
      {buckles.length > 0 ? (
        <S.BucklesWrapper $nbBuckles={buckles.length}>
          {buckles.map((item) => {
            return (
              <ProductItem
                key={item.sku}
                data={item}
                isClickable={true}
                nbBuckles={buckles.length}
                productType='buckle'
                selectedSku={selectedSku}
                setAllSelectedProducts={setAllSelectedProducts}
                setSelectedSku={setSelectedSku}
              />
            );
          })}
        </S.BucklesWrapper>
      ) : (
        <S.NoBuckles>
          <S.InfoBadge width={14} />
          {formatMessage(M.defined.noBucklesForSelection)}
        </S.NoBuckles>
      )}
    </Box>
  );
};
